import React, { useState } from 'react';
import { Formik } from 'formik';
import { isNil } from 'ramda';

import { createInvoice } from '../../../../../mutations/invoices';
import {
  validationSchema,
  initialValues,
} from '../../../../../forms/invoiceForm';
import StorePresenter from '../../../../../presenters/StorePresenter';
import Modal from '../../../../../components/Modal';
import { ErrorFlash } from '../../../../../components';

import AddInvoiceForm from './components/AddInvoiceForm';

const AddInvoiceModal = (props) => {
  const { isModalOpen, onModalClose, brand, listsId, relay } = props;
  const [errors, setErrors] = useState(null);

  const handleSubmit = (values) => {
    createInvoice(relay.environment, values, listsId, {
      onCompleted: handleSubmitSuccess,
    });
  };

  const handleSubmitSuccess = (response) => {
    const { errors } = response.createInvoice;
    if (errors) {
      setErrors(errors);
    } else {
      setErrors(null);
      onModalClose();
    }
  };

  return (
    <Modal
      title={`Create Invoice for ${StorePresenter.name(brand)}`}
      isModalOpen={isModalOpen}
      onClose={onModalClose}
    >
      {!isNil(errors) && <ErrorFlash errors={errors} message={errors} />}
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => handleSubmit(values, actions)}
        initialValues={initialValues(StorePresenter.id(brand))}
        validationSchema={validationSchema}
        render={(formikProps) => (
          <AddInvoiceForm {...formikProps} onModalClose={onModalClose} />
        )}
      />
    </Modal>
  );
};

export default AddInvoiceModal;
